import React from 'react';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardStepDetailListTemplate/Content/Content';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const ContentWithContext = (props) => {
  const {
    loadModalCollectionByLink,
    setModalCollection,
    refreshModalCollection,
  } = useModalContext();

  return (
    <Content
      {...props}
      loadLink={link => loadModalCollectionByLink(link.url())}
      setCollection={setModalCollection}
      refreshCollection={refreshModalCollection}
    />
  );
};

export default ContentWithContext;
